import {
  buyerCaptureException,
  logSessionRecovery,
  SessionRecoveryEvent,
  sessionRecoveryLevels,
} from '@diamond/shared/utils';
import * as Sentry from '@sentry/nextjs';

export function reportBuyerSessionRecovery(
  event: SessionRecoveryEvent,
  logLocally = true
) {
  try {
    if (logLocally) logSessionRecovery(event);
    const level = sessionRecoveryLevels[event.name];
    Sentry.addBreadcrumb({ category: 'session_recovery', level, data: event });
    if (level === 'info' && event.name !== 'redirect_requested') return;
    buyerCaptureException(
      { message: `Buyer session recovery: ${event.name}` },
      (scope) => {
        scope.setLevel(level);
        scope.setTag('feature', 'session_recovery');
        scope.setTag('session_event', event.name);
        scope.setContext('session_recovery', { ...event });
      }
    );
  } catch {
    // Diagnostics must not prevent logout or navigation.
  }
}

export async function flushSessionRecovery() {
  try {
    await Sentry.flush(1000);
  } catch {
    // Continue navigation when telemetry cannot be delivered.
  }
}
